/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ArrowDownSvg = () => (
  <svg width="1em" height="1em" viewBox="2.5 2.5 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="currentColor"/>
  </svg>
);

export const ArrowDownIcon = props => <Icon component={ArrowDownSvg} {...props} />;
